import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

export default function AdminHeader({ userRole, logout }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setStep((p) => (p + 1) % 5), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const menu = [
    'Home',
    'Reports & Analytics',
    'Feedback & Flags',
    'Get Self Assessment',
    'Dashboard'
  ];

  const go = (item) => {
    setOpen(false);
    switch (item) {
      case 'Home':
        if (userRole === 'admin') nav('/home');
        else nav('/');
        break;
      case 'Dashboard':
        nav('/admin/dashboard');
        break;
      case 'Reports & Analytics':
        nav('/admin/reports-analytics');
        break;
      case 'Feedback & Flags':
        nav('/admin/feedback-flags');
        break;
      case 'Get Self Assessment':
        window.open(
          'https://ai-microapp-template-development.streamlit.app/?template=Career+Advisor',
          '_blank'
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <header className="navbar-container">
        <div className="top-row">
          <div
            className="logo"
            onClick={() => {
              if (userRole === 'admin') nav('/home');
              else nav('/');
            }}
          >
            <img
              src="/footer/Robokalam Logo Real header 1.png"
              alt="Robokalam Logo"
              className="logo"
            />
          </div>

          <div className="top-center">
            <nav className="menu">
              {menu.map((m) => (
                <button
                  key={m}
                  onClick={() => go(m)}
                  className={m === 'Get Self Assessment' ? 'self-assessment-btn' : ''}
                >
                  {m}
                </button>
              ))}
            </nav>

          </div>

          <div className="top-actions">
            <button className="login-btn" onClick={logout}>
              Logout →
            </button>
          </div>

          <div className="hamburger" onClick={() => setOpen(true)}>
            ☰
          </div>
        </div>

        <div className="bottom-row">
          <h1 className="title">
            KodeZ –
            {step >= 1 && <span className="animated-word"> Learn.</span>}
            {step >= 2 && <span className="animated-word"> Launch.</span>}
            {step >= 3 && <span className="animated-word"> Lead.</span>}
          </h1>
        </div>
      </header>

      {open && (
        <div className="side-popup-overlay">
          <div className="side-popup" ref={ref}>
            {menu.map((m) => (
              <button
                key={m}
                onClick={() => go(m)}
                className={m === 'Get Self Assessment' ? 'self-assessment-btn' : ''}
              >
                {m}
              </button>
            ))}
            <button onClick={logout}>Logout</button>
          </div>

        </div>
      )}
    </>
  );
}
